import React, { PureComponent } from "react";

import trackPropType from "../../propTypes/track";

class Track extends PureComponent<{ track?: any; isRemote?: boolean, selected?: any, onClick?: any }> {
  media = React.createRef();

  static propTypes = {
    track: trackPropType.isRequired,
  };

  componentDidMount() {
    const { track } = this.props;

    console.log(track);

    track.attach(this.media.current);
  }

  render() {
    const { track, isRemote } = this.props;

    return (

        <track.kind
        onClick={()=>{
          console.log('on track clicked')
        }}
          className={
            track.kind === "video"
              ? !isRemote
                ? "video-local"
                : "video-remote"
              : ""
          }

          autoPlay
          ref={this.media}
        />
    );
  }
}

export default Track;
